export function getScreenWidth() {
  if (typeof window === "undefined") {
    return 0; // fallback during SSR
  }
  return window.screen?.width || window.innerWidth;
}
